import React, { useEffect, useState } from "react";
import "./AccountList.css";
import "../../Dashboard/Sidebar";
import ReactPaginate from "react-paginate";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";
import Moment from "moment";
import NotFoundData from "../../../Images/no-data-found.webp";
import "../../main_2.css";
const AccountList = ({
  accountDetails,
  accountList = [],
  match,
  getFilter,
  accountFilterContent = [],
  getCityByStateId,
  geoCity = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [filterView, setfilterView] = useState([{}]);
  const [requiredDataOnChange, setRequiredDataOnChange] = useState([
    { City: "" },
  ]);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [roleId, setRoleId] = useState("");

  useEffect(() => {
    let roleId = localStorage.getItem("role_id");
    setRoleId(roleId);
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    setPage(val?.selected + 1);
    if (match?.params.lead_id !== undefined) {
      await accountDetails(
        val?.selected + 1,
        match?.params.lead_id,
        searchValue,
        filterInputList
      );
    } else if (match?.params?.stage_id !== undefined) {
      await accountDetails(val?.selected + 1, 0, searchValue, [
        { stage_id: match?.params?.stage_id },
      ]);
    } else {
      await accountDetails(val?.selected + 1, 0, searchValue, filterInputList);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      const filter = JSON.parse(localStorage.getItem("account_filter"));
      if (filter !== null) {
        setFilterInputList(filter);
      }

      setIsLoading(true);
      if (match?.params.lead_id !== undefined) {
        await accountDetails(
          pageNo,
          match?.params.lead_id,
          searchValue,
          filterInputList
        );
      } else if (match?.params?.stage_id !== undefined) {
        await accountDetails(pageNo, 0, searchValue, [
          { stage: match?.params?.stage_id },
        ]);
      } else {
        await accountDetails(pageNo, 0, searchValue, filterInputList);
      }
      await getFilter();
      setIsLoading(false);
    })();
  }, []);

  const [open, setOpen] = useState(false);

  const handleSearch = async () => {
    if (searchValue === "") {
      return false;
    }
    window.localStorage.search_account = searchValue;
    if (match?.params.lead_id !== undefined) {
      setIsLoading(true);
      await accountDetails(
        pageNo,
        match?.params.lead_id,
        searchValue,
        filterInputList,
        isGlobalSearch
      );
      setIsLoading(false);
    } else {
      setIsLoading(true);
      await accountDetails(
        pageNo,
        0,
        searchValue,
        filterInputList,
        isGlobalSearch
      );
      setIsLoading(false);
    }
  };

  const handleFilter = async (key, value, stringValue = "") => {
    if (key === "state") {
      await getCityByStateId(value);
    }
    const list = [...filterInputList];
    const view = [...filterView];
    list[0][key] = value;
    view[0][key] = value;
    if (stringValue !== "") {
      view[0][key] = stringValue;
      setfilterView(view);
    } else {
      setfilterView(view);
    }
    setFilterInputList(list);
  };

  useEffect(() => {
    if (geoCity && geoCity?.data !== undefined) {
      requiredDataOnChange[0]["City"] = geoCity?.data;
      setRequiredDataOnChange(requiredDataOnChange);
    }
  }, [geoCity, accountFilterContent]);

  const handleSubmitFilter = async () => {
    setOpen(false);
    setIsLoading(true);
    if (match?.params.lead_id !== undefined) {
      await accountDetails(
        pageNo,
        match?.params.lead_id,
        searchValue,
        filterInputList
      );
    } else {
      await accountDetails(pageNo, 0, searchValue, filterInputList);
    }
    setIsLoading(false);
  };

  const handleRemoveFilter = async (key) => {
    if (key !== "") {
      delete filterView[0][key];
      delete filterInputList[0][key];
      delete filterInputList[0][key + "_name"];
      setfilterView(filterView);
      setFilterInputList(filterInputList);
      setIsLoading(true);
      if (match?.params.lead_id !== undefined) {
        await accountDetails(
          pageNo,
          match?.params.lead_id,
          searchValue,
          filterInputList
        );
      } else {
        await accountDetails(pageNo, 0, searchValue, filterInputList);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (isFilterRemove) {
        setfilterView([{}]);
        setFilterInputList([{}]);
        setIsLoading(true);
        if (match?.params.lead_id !== undefined) {
          await accountDetails(pageNo, match?.params.lead_id, searchValue);
        } else {
          await accountDetails(pageNo, 0, searchValue);
        }
        setIsLoading(false);
        setIsRemoveFilter(false);
      }
    })();
  }, [isFilterRemove]);

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && searchValue !== "") {
      event.preventDefault();
      if (match?.params.lead_id !== undefined) {
        setIsLoading(true);
        await accountDetails(
          pageNo,
          match?.params.lead_id,
          searchValue,
          filterInputList,
          isGlobalSearch
        );
        setIsLoading(false);
      } else {
        setIsLoading(true);
        await accountDetails(
          pageNo,
          0,
          searchValue,
          filterInputList,
          isGlobalSearch
        );
        setIsLoading(false);
      }
    }
  };

  const removeSearchFilter = async () => {
    delete window.localStorage.search_account;
    setIsLoading(true);
    if (match?.params.lead_id !== undefined) {
      await accountDetails(pageNo, match?.params.lead_id);
    } else if (match?.params?.stage_id !== undefined) {
      await accountDetails(pageNo, 0, "", [{ stage: match?.params?.stage_id }]);
    } else {
      await accountDetails(pageNo, 0);
    }
    await getFilter();
    setIsLoading(false);
  };

  return (
    <>
      {/*<Sidebar/>*/}
      {/* section start  */}
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Account List"} />
            {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="row b-13">
                  {/*<div className="form-check form-switch global-search">*/}
                  {/*    <input type="checkbox" id="switch" onChange={(e) => setIsGlobalSearch(e.target.checked)}/>*/}
                  {/*    <label className="radio-btn" for="switch">Global Search</label>*/}
                  {/*    <span className="serach-title">Search account globally..</span>*/}
                  {/*</div>*/}
                </div>
                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                  <div className="row col-md-12">
                    <div className="col-md-6 col-sm-6 d-flex mt-20px">
                      <form className="form-inline mr-auto w-90 navbar-search">
                        <div className="d-flex w-100">
                          <input
                            type="text"
                            className="form-control bg-light border-0 small list-filter"
                            placeholder={
                              isGlobalSearch
                                ? "Search account globally.."
                                : "Search Account..."
                            }
                            aria-label="Search"
                            aria-describedby="basic-addon2"
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                            onKeyDown={handleKeyDown}
                          />
                          <div className="remove-search-filter">
                            <i
                              className="fa fa-times"
                              aria-hidden="true"
                              onClick={removeSearchFilter}
                            ></i>
                          </div>
                          <div className="btn-search">
                            <button
                              className="btn btn-primary lh-32 border-left-tr-tb"
                              type="button"
                              onClick={(e) => handleSearch()}
                            >
                              <i className="fas fa-search fa-sm"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                      {/* <h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                    </div>
                    <div className="col-md-6 cs-pos">
                      <button
                        onClick={() => setOpen(!open)}
                        className="btn btn-sm btn-primary mr-1 btn-filter btn-filter-2"
                        type="button"
                      >
                        <i className="fa fa-filter lh-35 pd-3"></i>
                      </button>
                    </div>
                    <div className="col-md-3 cs-pos hide">
                      <button
                        style={{ float: "right" }}
                        className="btn btn-sm btn-primary mr-1"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        // onClick={() => setOpen(true)}
                      >
                        <i className="fa fa-filter"></i>
                      </button>

                      <a
                        href={
                          match?.params?.lead_id !== undefined
                            ? `/add-account/${match?.params?.lead_id}`
                            : "/add-account"
                        }
                        className="btn btn-sm btn-success mr-2 btn-plus"
                        type="button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-lg"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                          />
                        </svg>
                        <span className="d-ac-btn"> Account </span>
                      </a>
                    </div>
                  </div>
                </div>
                {/* Filter View */}
                {filterView[0] !== undefined &&
                  Object.keys(filterView[0]).length > 0 && (
                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                      <div className="row pd-filter-div">
                        <div className="col-md-12 col-sm-12 d-flex">
                          <div className="applied-filter">
                            {Object.keys(filterView[0]).map((val, i) => {
                              return (
                                <>
                                  <span className="fd-1">
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {" - " + filterView[0][val]}
                                    <i
                                      className="bi bi-x-circle"
                                      onClick={(e) => {
                                        handleRemoveFilter(val);
                                      }}
                                    ></i>
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {/* Filter View End*/}
                <div className="row">
                  {/*CARD START*/}
                  {accountList &&
                    accountList?.data !== undefined &&
                    accountList?.data !== [] &&
                    accountList?.data.map((val, i) => {
                      return (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <div className="card-big-shadow">
                              <div
                                className="card card-just-text"
                                data-background=""
                                data-color=""
                                data-radius="none"
                              >
                                <div className="content">
                                  <h6 className="category mrg-b-12">
                                    <div
                                      className="header-ui-item"
                                      style={{
                                        backgroundColor: val?.stage_color,
                                      }}
                                    >
                                      {val?.stage_name}
                                    </div>
                                    <div className="row">
                                      <div
                                        className="col-10"
                                        style={{
                                          color: "#000",
                                          fontSize: "20px",
                                          textAlign: "left",
                                          paddingLeft: "20px",
                                        }}
                                      >
                                        <div className="d-flex">
                                          {/*{parseInt(val?.is_draft) === 1 &&*/}
                                          {/*    <div className="draft">D&nbsp;&nbsp;</div>*/}
                                          {/*}*/}
                                          {val?.client_name}
                                          <span className="ac-type">
                                            ({val?.project_name})
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-2">
                                        {/*TOGGLE*/}
                                        <div className="dropdown dropdown-data show">
                                          <span
                                            className=""
                                            href="#"
                                            role="button"
                                            id="dropdownMenuLink"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                          >
                                            <i className="fas fa-bars"></i>
                                          </span>
                                          <div
                                            className="dropdown-menu show-dpd"
                                            aria-labelledby="dropdownMenuLink"
                                          >
                                            <a
                                              href={
                                                match?.params?.lead_id !==
                                                undefined
                                                  ? `/view-account/${val?.id}/${match?.params?.lead_id}`
                                                  : `view-account/${val?.id}`
                                              }
                                              className="dropdown-item"
                                            >
                                              <i className="bi bi-eye"></i>{" "}
                                              Account
                                            </a>
                                            <a
                                              className="dropdown-item"
                                              href={`inspection-list/${val?.lead_id}`}
                                            >
                                              <i className="fas fa-wrench"></i>{" "}
                                              Inspection
                                            </a>
                                            {val?.inspection_status == 4 && (
                                              <a
                                                className="dropdown-item"
                                                href={`inspection-form/${val?.lead_id}`}
                                              >
                                                <i className="fas fa-eye"></i>{" "}
                                                Approved
                                              </a>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/*<div className="d-flex">*/}
                                    {/*    <p><b>Client Name</b></p>*/}
                                    {/*    <p>{val?.client_name}</p>*/}
                                    {/*</div>*/}
                                    <div className="row list-view">
                                      {val?.id !== null && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-paint-brush"></i>
                                            &nbsp;&nbsp;Ac. No
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.id}
                                          </div>
                                        </div>
                                      )}
                                      {val?.account_type !== null && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="bi bi-person-lines-fill"></i>
                                            &nbsp;&nbsp;Ac. Sub Type
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.account_type}
                                          </div>
                                        </div>
                                      )}
                                      {val?.city_name !== null &&
                                        val?.zone_name !== null && (
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="fas fa-map-marker"></i>
                                              &nbsp;&nbsp;Location
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              {val?.city_name}
                                            </div>
                                          </div>
                                        )}

                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i className="fas fa-user-tie"></i>
                                          &nbsp;&nbsp;Created By
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                          <span
                                            className="trigger"
                                            data-tooltip-id="1"
                                            title={val?.user_name}
                                          >
                                            {val?.user_name}
                                          </span>
                                        </div>
                                      </div>

                                      {val?.infra_project_id && (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-paint-brush"></i>
                                            &nbsp;&nbsp;Infra ID
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            {val?.infra_project_id}
                                          </div>
                                        </div>
                                      )}

                                      {val?.last_activity_on_account !== null &&
                                      val?.last_activity_on_account !==
                                        undefined ? (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt"></i>
                                            &nbsp;&nbsp;Last action date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="2"
                                              title={
                                                Moment(
                                                  val?.last_activity_on_account
                                                    ?.activity_date
                                                ).format("DD-MM-YYYY") +
                                                " ( " +
                                                val?.last_activity_on_account
                                                  ?.activity_type?.name +
                                                " )"
                                              }
                                            >
                                              {Moment(
                                                val?.last_activity_on_account
                                                  ?.activity_date
                                              ).format("DD-MM-YYYY") +
                                                " ( " +
                                                val?.last_activity_on_account
                                                  ?.activity_type?.name +
                                                " )"}
                                            </span>
                                          </div>
                                        </div>
                                      ) : val?.opportunities.length > 0 ? (
                                        <>
                                          <div className="mb-flex">
                                            <div className="col-md-6 col-sm-6 no-wrap">
                                              <i className="fas fa-calendar-alt"></i>
                                              &nbsp;&nbsp;Last Action Date
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              <span
                                                className="trigger"
                                                data-tooltip-id="3"
                                                title={
                                                  Moment(
                                                    val?.opportunities[
                                                      val?.opportunities
                                                        .length - 1
                                                    ]?.created_at
                                                  ).format("DD-MM-YYYY") +
                                                  " ( Opp. create )"
                                                }
                                              >
                                                {Moment(
                                                  val?.opportunities[
                                                    val?.opportunities.length -
                                                      1
                                                  ]?.created_at
                                                ).format("DD-MM-YYYY") +
                                                  " ( Opp. create )"}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt"></i>
                                            &nbsp;&nbsp;Last Action Date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="3"
                                              title={
                                                Moment(val?.created_at).format(
                                                  "DD-MM-YYYY"
                                                ) + " ( Account created )"
                                              }
                                            >
                                              {Moment(val?.created_at).format(
                                                "DD-MM-YYYY"
                                              ) + " ( Account created )"}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      {val?.next_activity_on_account !==
                                      null ? (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt calendar-gr"></i>
                                            &nbsp;&nbsp;Next action date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={
                                                Moment(
                                                  val?.next_activity_on_account
                                                    ?.activity_date
                                                ).format("DD-MM-YYYY") +
                                                " ( " +
                                                val?.next_activity_on_account
                                                  ?.activity_type?.name +
                                                " )"
                                              }
                                            >
                                              {Moment(
                                                val?.next_activity_on_account
                                                  ?.activity_date
                                              ).format("DD-MM-YYYY") +
                                                " ( " +
                                                val?.next_activity_on_account
                                                  ?.activity_type?.name +
                                                " )"}
                                            </span>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="mb-flex">
                                          <div className="col-md-6 col-sm-6 no-wrap">
                                            <i className="fas fa-calendar-alt calendar-gr"></i>
                                            &nbsp;&nbsp;Next Action Date
                                          </div>
                                          <div className="col-md-6 col-sm-6">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={
                                                val?.first_contact_date !== null
                                                  ? Moment(
                                                      val?.first_contact_date
                                                    ).format("DD-MM-YYYY") +
                                                    " ( first contract date )"
                                                  : null
                                              }
                                            >
                                              {val?.first_contact_date !== null
                                                ? Moment(
                                                    val?.first_contact_date
                                                  ).format("DD-MM-YYYY") +
                                                  " ( first contract date )"
                                                : null}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <hr />
                                    <div
                                      className="row list-view-links"
                                      style={{ padding: "12px" }}
                                    >
                                      <ul>
                                        <li></li>
                                        {val?.last_activity_v2_on_account ===
                                          null &&
                                          val?.stage_name !== "Draft" && (
                                            <li style={{ margin: "-8px" }}>
                                              <a
                                                href={
                                                  match?.params?.lead_id !==
                                                  undefined
                                                    ? `/opportunity-list/${val?.id}/${match?.params?.lead_id}`
                                                    : `opportunity-list/${val?.id}`
                                                }
                                              >
                                                <i className="bi bi-list"></i>
                                                &nbsp;&nbsp;Opportunity
                                              </a>
                                            </li>
                                          )}
                                        {val?.last_activity_v2_on_account !==
                                          undefined &&
                                          val?.last_activity_v2_on_account !==
                                            null &&
                                          val?.last_activity_v2_on_account
                                            ?.id !== undefined && (
                                            <li style={{ margin: "-8px" }}>
                                              <a
                                                href={`last-meeting-history/${val?.last_activity_v2_on_account?.id}`}
                                              >
                                                <i className="bi bi-list"></i>
                                                &nbsp;&nbsp;Last meeting
                                              </a>
                                            </li>
                                          )}
                                        {/*<li><a*/}
                                        {/*    href={`account-activity-list/${val?.id}`}><i*/}
                                        {/*    className="bi bi-alarm"></i>&nbsp;&nbsp;Activity</a>*/}
                                        {/*</li>*/}
                                      </ul>
                                    </div>
                                  </h6>
                                  {(parseInt(roleId) === 5 ||
                                    parseInt(roleId) === 6 ||
                                    parseInt(roleId) === 7 ||
                                    parseInt(roleId) === 16 ||
                                    parseInt(roleId) === 4 ||
                                    parseInt(roleId) === 57 || 
                                    parseInt(roleId) === 79) && (
                                    <div className="col-sm-6">
                                      <a
                                        href={
                                          match?.params?.lead_id !== undefined
                                            ? `/add-account/${match?.params?.lead_id}`
                                            : `search-universe-business`
                                        }
                                        className="draft-float"
                                      >
                                        <p
                                          className="my-float"
                                          style={{ marginTop: "20px" }}
                                        >
                                          <i
                                            className="fa fa-plus"
                                            aria-hidden="true"
                                          ></i>
                                        </p>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}

                  {accountList &&
                    accountList?.data !== undefined &&
                    accountList?.data.length > 0 && (
                      <div className="panel-pagination-col panel-table-pagination">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={accountList?.total / accountList?.per_page}
                          forcePage={accountList?.current_page - 1}
                          pageRangeDisplayed={4}
                          onPageChange={onPageChange}
                          activeClassName={"active"}
                        />
                      </div>
                    )}

                  {accountList &&
                    accountList?.data !== undefined &&
                    accountList?.data.length === 0 && (
                      <>
                        <img src={NotFoundData} className="not-found-data" />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                        {(parseInt(roleId) === 5 ||
                          parseInt(roleId) === 6 ||
                          parseInt(roleId) === 7 ||
                          parseInt(roleId) === 16 ||
                          parseInt(roleId) === 4 ||
                          parseInt(roleId) === 57 || 
                          parseInt(roleId) === 79) && (
                          <div className="col-sm-6">
                            <a
                              href={
                                match?.params?.lead_id !== undefined
                                  ? `/add-account/${match?.params?.lead_id}`
                                  : `search-universe-business`
                              }
                              className="draft-float"
                            >
                              <p
                                className="my-float"
                                style={{ marginTop: "20px" }}
                              >
                                <i
                                  className="fa fa-plus"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            </a>
                          </div>
                        )}
                      </>
                    )}
                  {/*PAGINATION END*/}
                </div>
              </div>
            </div>
          </div>
        </div>

        <BottomMenu
          open={open}
          setOpen={setOpen}
          filterContent={accountFilterContent}
          handleFilter={handleFilter}
          handleSubmitFilter={handleSubmitFilter}
          requiredDataOnChange={requiredDataOnChange}
          setIsRemoveFilter={setIsRemoveFilter}
        />
      </div>
      {/* section ends */}
    </>
  );
};

export default AccountList;
